import type React from 'react';

import ListItem from '@mui/material/ListItem';
import { useTranslation } from 'react-i18next';
import { scaleConstants } from 'tods-competition-factory';

import { RatingTypeEnum } from 'components/panels/eventsSplitDraws/selectedEvent/rankingsAndRatings/types';
import { useStyles } from 'components/tables/competitors/main/styles';
import { BodyLarge } from 'components/typography/Typography';

const { RATING, RANKING } = scaleConstants;

interface RankingAndRatingsSeedItemsProps {
  handleAutoSeedOpen: (type: string, ratingType?: RatingTypeEnum) => void;
  isRankingEnabled: boolean;
  isWtnEnabled: boolean;
  isNtrpEnabled: boolean;
}

const RankingAndRatingsSeedItems: React.FC<React.PropsWithChildren<RankingAndRatingsSeedItemsProps>> = ({
  handleAutoSeedOpen,
  isRankingEnabled,
  isWtnEnabled,
  isNtrpEnabled,
}) => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  return (
    <>
      {isRankingEnabled && (
        <ListItem
          className={classes.listItem}
          onClick={() => {
            handleAutoSeedOpen(RANKING);
          }}
        >
          <BodyLarge>{t('autoseedRanking')}</BodyLarge>
        </ListItem>
      )}
      {isNtrpEnabled && (
        <ListItem className={classes.listItem} onClick={() => handleAutoSeedOpen(RATING, RatingTypeEnum.NTRP)}>
          <BodyLarge>{t('autoseedRating', { ratingType: RatingTypeEnum.NTRP })}</BodyLarge>
        </ListItem>
      )}
      {isWtnEnabled && (
        <ListItem className={classes.listItem} onClick={() => handleAutoSeedOpen(RATING, RatingTypeEnum.WTN)}>
          <BodyLarge>{t('autoseedRating', { ratingType: RatingTypeEnum.WTN })}</BodyLarge>
        </ListItem>
      )}
    </>
  );
};

export default RankingAndRatingsSeedItems;
